import { IContent } from "@/models/Content.model";

const state = { content: [], showNav: true };
const getters = {
  // @ts-ignore
  getContent: (state) => state.content,
  // @ts-ignore
  getCarouselContent: (state) =>
    // @ts-ignore
    state.content.find((content) => content.section == "carousel"),
  // @ts-ignore
  getAboutContent: (state) =>
    // @ts-ignore
    state.content.find((content) => content.section == "about"),
  // @ts-ignore
  getConferenceContent: (state) =>
    // @ts-ignore
    state.content.find((content) => content.section == "info"),
  // @ts-ignore
  getPublicationContent: (state) =>
    // @ts-ignore
    state.content.find((content) => content.section == "publication"),
  // @ts-ignore
  getProgrammeContent: (state) =>
    // @ts-ignore
    state.content.find((content) => content.section == "programme"),
  // @ts-ignore
  getVenueContent: (state) =>
    // @ts-ignore
    state.content.find((content) => content.section == "venue"),
  // @ts-ignore
  getRegistrationContent: (state) =>
    // @ts-ignore
    state.content.find((content) => content.section == "registration"),
  // @ts-ignore
  getDatesContent: (state) =>
    // @ts-ignore
    state.content.find((content) => content.section == "dates"),
  // @ts-ignore
  getSponsorsContent: (state) =>
    // @ts-ignore
    state.content.find((content) => content.section == "sponsors"),
  // @ts-ignore
  showNav: (state) => state.showNav,
};

const mutations = {
  // @ts-ignore
  setContent(state, content: IContent[]) {
    state.content = content;
  },
  // @ts-ignore
  setShowNav(state, showNav: boolean) {
    state.showNav = showNav;
  },
};

const actions = {};

export default { state, getters, mutations, actions };
